import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";

export default function useCourseEnrollments(){

    const {id} = useParams()

    return useQuery({

        queryKey: ['design', id, 'enrollments'],

        queryFn: () => API.get(`/design/courses/${id}/enrollments`)
            .then(r => r.data),

        staleTime: 'Infinity',
        refetchInterval: false,
        refetchIntervalInBackground: false,
        refetchOnMount: true,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
    })
};
